module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/eventhost-c4de85713786f3dd5de7ea68bb222fac.webp";